import * as React from 'react';
import {Link} from 'react-router-dom';

import {IconAvatar} from '../../../avatar/icon-avatar';
import {colors} from '../../../colors/colors';
import {AccountIcon} from '../../../icon/svg/account-icon';
import {CompanyContactIcon} from '../../../icon/svg/company-contact-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ExternalLinkIcon} from '../../../icon/svg/external-link-icon';
import {RelativeTimestamp} from '../../../timestamp/relative-timestamp';
import {TwoLine} from '../../../two-line/two-line';

import styles from './company-header.module.css';

export type CompanyHeaderDetails = {
    name: string;
    timestamp: number;
    wasConvertedAutomatically: boolean;
    htmlUrlPath?: string;
};

type Props = CompanyHeaderDetails;

export function CompanyHeader(props: Props) {
    let Icon,
        iconColor,
        backgroundColor,
        iconSize = 28,
        companyName = props.name,
        timestampText;

    if (props.htmlUrlPath) {
        Icon = AccountIcon;
        iconColor = colors.white;
        backgroundColor = colors.company;
        iconSize = 24;
        // @ts-expect-error
        companyName = (
            <Link to={props.htmlUrlPath} target='_blank' rel='noopener noreferrer'>
                {props.name}
                <ExternalLinkIcon size={13} wrapWithDiv={false} />
            </Link>
        );
        timestampText = 'Added';
    } else {
        Icon = CompanyContactIcon;
        timestampText = 'Seen';
    }

    return (
        <div className={styles['company-header-container']}>
            <TwoLine
                topRow={
                    <div title={props.name} className={styles['company-name']}>
                        {companyName}
                    </div>
                }
                bottomRow={
                    <div className={styles['company-timestamp']}>
                        {props.wasConvertedAutomatically ? (
                            'This company already existed in Nutshell'
                        ) : (
                            <>
                                <div>{timestampText}&nbsp;</div>
                                <RelativeTimestamp datetime={props.timestamp} />
                            </>
                        )}
                    </div>
                }
                avatar={
                    <IconAvatar
                        icon={Icon}
                        avatarSize={48}
                        iconSize={iconSize}
                        backgroundColor={backgroundColor}
                        iconColor={iconColor}
                    />
                }
            />
        </div>
    );
}
